import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

/**
 * Hero section with logo, headline and call to action.
 */
export function LandingHero() {
  return (
    <section className="relative pt-40 pb-24 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="mb-8"
        >
          <img
            src="/vrmeet_logo.png"
            alt="VR Meet"
            className="h-32 w-32 mx-auto animate-float"
          />
        </motion.div>

        <motion.h1
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight mb-6"
        >
          <span className="text-gray-900">Meet in </span>
          <span className="bg-gradient-to-r from-brand-blue via-brand-teal to-brand-green bg-clip-text text-transparent">
            Virtual Reality
          </span>
        </motion.h1>

        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-xl text-gray-500 max-w-2xl mx-auto mb-10 leading-relaxed"
        >
          Meet from your browser or headset and share the same immersive space.
          Join from anywhere, appear together in immersive 3D rooms.
        </motion.p>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Link
            to="/register"
            className="group relative px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-brand-blue via-brand-teal to-brand-green rounded-2xl overflow-hidden transition-all hover:shadow-xl hover:shadow-brand-teal/30 hover:-translate-y-0.5"
          >
            <span className="relative z-10">Get Started</span>
            <div className="absolute inset-0 bg-gradient-to-r from-brand-green via-brand-teal to-brand-blue opacity-0 group-hover:opacity-100 transition-opacity" />
          </Link>

          <Link
            to="/login"
            className="px-8 py-4 text-lg font-medium text-gray-600 hover:text-gray-900 border border-gray-200 rounded-2xl hover:bg-gray-50 hover:border-gray-300 transition-all"
          >
            Sign in to your account
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
